import React, { useMemo, useState } from "react";
import styled from "styled-components";
import FilamentTile, {
  FilamentConfig,
} from "../../components/core-components/FilamentTile.tsx";
import PaginatedItems from "../../components/PaginatedItems.tsx";
import {
  getFilaments,
  updateFilamentWeight,
} from "../../../services/filamentService.js";
import { useQuery } from "@tanstack/react-query";
import AddFilamentComponent from "../../components/core-components/AddFilamentComponent.tsx";
import Modal from "../../components/core-components/Modal.tsx";
import { toast, ToastContainer } from "react-toastify";
import Button from "../../components/core-components/Button.tsx";
import { TbLabel, TbPlugConnected, TbPlugConnectedX } from "react-icons/tb";
import { usePrinter } from "../../../hooks/usePrinter.ts";
import { MdOutlineVideoLabel } from "react-icons/md";
import Loader from "../../components/core-components/Loader.tsx";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5%;
  width: 90%;
  padding: 20px 0;
  color: var(--tertiary-font-color);
`;
const Header = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

const Sort = styled.div`
  margin-right: 1rem;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  color: var(--tertiary-font-color);
  font-family: Georgia, serif;

  @media (min-width: 820px) {
    margin-left: 2rem;
  }

  select {
    padding: 4px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    gap: 1rem;
  }

  select:focus {
    outline: none;
  }
`;

const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
`;

const SwitchInput = styled.input`
  width: 40px;
  height: 20px;
  position: relative;
  appearance: none;
  background: #c6c6c6;
  outline: none;
  border-radius: 20px;
  transition: 0.3s;

  &:checked {
    background: var(--primary-brown);
  }

  &::before {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    top: 1px;
    left: 1px;
    background: white;
    transition: 0.3s;
  }

  &:checked::before {
    left: 21px;
  }
`;

interface Props {
  isAdminView: boolean;
}
const notify = () =>
  toast.success("Filament adăugat cu succes !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });

const notifyError = () =>
  toast.error("Filamentul nu s-a putut adăuga !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });
const FilamentListingPage: React.FC<Props> = ({ isAdminView }) => {
  // const languageCode = useSelector((state: any) => state.settings.languageCode);
  const [isFilamentModalOpen, setFilamentModalOpen] = React.useState(false);
  const [sortOrder, setSortOrder] = useState("recomandation");

  const {
    connectPrinter,
    disconnectPrinter,
    printLabel,
    isPrinterConnected,
    canvasRef,
    isPrinting,
    setIsSmallPrinter,
    isSmallPrinter,
  } = usePrinter();

  React.useEffect(() => {
    return () => {
      disconnectPrinter().catch(console.error);
    };
  }, []);

  const handleSortChange = (event:any) => {
    setSortOrder(event.target.value);
  };

  const {
    data: filaments,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["filaments"],
    queryFn: getFilaments,
  });

  const handleFilamentUpdate = async (
    filamentID: number,
    updatedWeight: number
  ) => {
    try {
      // Update the weight on the server
      await updateFilamentWeight(filamentID, updatedWeight);

      // Refetch the filaments after update
      refetch();
    } catch (error) {
      console.error("Error updating filament weight:", error);
    }
  };
const sortedFilament = useMemo(() => {
  if (!filaments) return [];
  const sorted = [...filaments].sort((a, b) => {
    if (sortOrder === "ascending-type")
      return a.filamentConfig.material.localeCompare(
        b.filamentConfig.material
      );
    if (sortOrder === "ascending-name")
      return a.colorName.localeCompare(b.colorName);
    return 0;
  });
    const filteredOos = sorted.filter(
    (filament) =>filament.filamentConfig.weight > 0

      
  );
  const filtered = filteredOos.filter(
    (filament, index, self) =>
      index === self.findIndex(f => f.colorCode === filament.colorCode) 
  );
  console.log({ sorted, filtered });
  return filtered;
}, [sortOrder, filaments]);

  return (
    <Wrapper>
      {isAdminView && (
        <Header>
          <div style={{ display: "flex", gap: "1rem", flexDirection: "row" }}>
            <canvas
              id="canvas"
              ref={canvasRef}
              width={isSmallPrinter ? 320 : 384}
              height={isSmallPrinter ? 104 : 240}
              style={{ display: "none", border: "1px solid black" }}
            ></canvas>

            <Button
              id="add-filament-button-modal"
              onClick={() => setFilamentModalOpen(true)}
              text={"Adaugă filament"}
              backgroundColor={"white"}
              outline="var(--secondary-green)"
              color="var(--secondary-green)"
            />

            {isPrinterConnected ? (
              <>
                <Button
                  id="disconnect-printer-button"
                  onClick={() => {
                    disconnectPrinter();
                    //   setIsPrinterConnected(false);
                  }}
                  icon={<TbPlugConnectedX />}
                  backgroundColor={"white"}
                  outline="var(  --primary-brown)"
                  color="var(  --primary-brown)"
                />
                <div
                  style={{ display: "flex", gap: "8px", alignItems: "center" }}
                >
                  <div
                    style={{
                      color: "gray",
                      fontSize: "18px",
                      marginTop: "4px",
                    }}
                  >
                    <MdOutlineVideoLabel />
                  </div>

                  <SwitchLabel>
                    <SwitchInput
                      type="checkbox"
                      checked={isSmallPrinter}
                      onChange={() => {
                        setIsSmallPrinter(!isSmallPrinter);
                      }}
                    />
                    <div
                      style={{
                        color: "gray",
                        fontSize: "24px",
                        marginTop: "4px",
                      }}
                    >
                      <TbLabel />
                    </div>
                  </SwitchLabel>
                </div>
                {isPrinting && <Loader isSmall />}
              </>
            ) : (
              <Button
                id="connect-printer-button"
                onClick={() => {
                  connectPrinter();
                  //  setIsPrinterConnected(true);
                }}
                icon={<TbPlugConnected />}
                backgroundColor={"white"}
                outline="var(--secondary-green)"
                color="var(--secondary-green)"
              />
            )}
          </div>

          <Sort>
            <label htmlFor="sort">Sortare după:</label>
            <select
              name="sort"
              id="sort"
              value={sortOrder}
              onChange={handleSortChange}
            >
              <option value="recomandation">Default</option>
              <option value="ascending-name">Nume culoare alfabetic</option>
              <option value="ascending-type">Tip filament alfabetic</option>
            </select>
          </Sort>
        </Header>
      )}
      {isFilamentModalOpen && (
        <Modal
          name="add-filament-modal"
          transparent
          content={
            <AddFilamentComponent
              closeAddMode={(result) => {
                setFilamentModalOpen(false);
                if (result === "success") {
                  notify();
                  refetch();
                } else if (result === "error") {
                  notifyError();
                }
              }}
            />
          }
        />
      )}
      <Container>
        <PaginatedItems
          items={sortedFilament || []}
          maxItemsPerPage={30}
          isLoading={isLoading}
          renderItem={(filament: {
            colorCode: string;
            colorName: string;
            filamentConfig: FilamentConfig;
          }) => (
            <FilamentTile
              printLabel={
                isPrinterConnected && !isPrinting ? printLabel : undefined
              }
              colorCode={filament.colorCode}
              colorName={filament.colorName}
              isAdminMode={isAdminView}
              filamentConfig={filament.filamentConfig}
              onWeightUpdated={handleFilamentUpdate}
            />
          )}
        />
      </Container>

      <ToastContainer />
    </Wrapper>
  );
};

export default FilamentListingPage;
